import React, { useState } from 'react';
import { Label } from '../../components/ui/label';
import ContactSearchInput from '../shared/ContactSearchInput';

// Contact picker for the create dialogs (ticket 187): the shared server-side contact search, so the
// whole tenant is reachable instead of the first 200 contacts. Typing searches; a pick calls
// onPick(contact); editing the text after a pick calls onPick(null). The text is seeded from
// `contact`, because the dialog unmounts its content on close.
export default function OppContactField({ contact, onPick, testid = 'opp-contact-select' }) {
  const [text, setText] = useState(contact?.display_name || '');
  return (
    <div>
      <Label>Contact</Label>
      <ContactSearchInput
        value={text}
        onChange={(v) => { setText(v); if (contact && v !== contact.display_name) onPick(null); }}
        onPick={(c) => { setText(c.display_name || ''); onPick(c); }}
        testid={testid}
        placeholder="Search by name, email or phone"
        className="mt-1 w-full h-9 rounded-md border border-slate-200 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#6BA82E]/40"
      />
    </div>
  );
}
